import React from 'react';

interface OrDividerProps {
  /** Texto entre as linhas. Default "OU ENTRE COM E-MAIL". */
  label?: string;
}

/**
 * Divider horizontal com label centralizado, usado entre o
 * `<GoogleButton>` e o form de email/senha.
 *
 * Origem: templates/Login com Google/src/brand.jsx <OrDivider>.
 */
export function OrDivider({ label = 'OU ENTRE COM E-MAIL' }: OrDividerProps) {
  return (
    <div className="auth-or-divider" role="separator">
      <span className="auth-or-divider__line" />
      <span className="auth-or-divider__label">{label}</span>
      <span className="auth-or-divider__line" />
    </div>
  );
}
